import { render, staticRenderFns } from "./ChallengeTabHeader.vue?vue&type=template&id=3ae13d7d&scoped=true&"
import script from "./ChallengeTabHeader.vue?vue&type=script&lang=js&"
export * from "./ChallengeTabHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae13d7d",
  null
  
)

export default component.exports